module.exports = __webpack_public_path__ + "static/media/clamp.399e7236.webp";